import React, { useEffect } from 'react';

const Dashboard = () => {
  useEffect(() => {
    // Adia a inicialização dos gráficos para garantir que a biblioteca Chart.js tenha sido carregada
    const initializeCharts = () => {
        // Verifica se a biblioteca Chart.js está disponível no escopo global
        if (typeof window.Chart === 'undefined') {
            console.error("Chart.js não foi carregado. A tentar novamente em 100ms.");
            setTimeout(initializeCharts, 100); // Tenta novamente após um curto período
            return;
        }

        let evolutionChartInstance, distributionChartInstance;

        // Gráfico de Evolução
        const evolutionCtx = document.getElementById('evolutionChart');
        if (evolutionCtx) {
            evolutionChartInstance = new window.Chart(evolutionCtx.getContext('2d'), {
                type: 'line',
                data: {
                    labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    datasets: [{
                        label: 'Processos Concluídos',
                        data: [12, 19, 15, 25, 22, 30, 28, 35, 32, 38, 42, 45],
                        borderColor: '#D4AF37',
                        backgroundColor: 'rgba(212, 175, 55, 0.1)',
                        borderWidth: 3,
                        fill: true,
                        tension: 0.4
                    }, {
                        label: 'Novos Processos',
                        data: [8, 12, 18, 15, 20, 25, 22, 28, 26, 30, 35, 38],
                        borderColor: '#3b82f6',
                        backgroundColor: 'rgba(59, 130, 246, 0.1)',
                        borderWidth: 3,
                        fill: true,
                        tension: 0.4
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: { legend: { labels: { color: '#ffffff', font: { size: 12 } } } },
                    scales: {
                        x: { ticks: { color: '#ffffff' }, grid: { color: 'rgba(255, 255, 255, 0.1)' } },
                        y: { ticks: { color: '#ffffff' }, grid: { color: 'rgba(255, 255, 255, 0.1)' } }
                    }
                }
            });
        }

        // Gráfico de Distribuição
        const distributionCtx = document.getElementById('distributionChart');
        if (distributionCtx) {
            distributionChartInstance = new window.Chart(distributionCtx.getContext('2d'), {
                type: 'doughnut',
                data: {
                    labels: ['Civil', 'Criminal', 'Trabalhista', 'Tributário', 'Ambiental'],
                    datasets: [{
                        data: [35, 25, 20, 12, 8],
                        backgroundColor: ['#D4AF37', '#3b82f6', '#10b981', '#f59e0b', '#ef4444'],
                        borderWidth: 0
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'bottom',
                            labels: { color: '#ffffff', font: { size: 12 }, padding: 20 }
                        }
                    }
                }
            });
        }
        
        // Função de limpeza para desmontar os gráficos
        return () => {
            if (evolutionChartInstance) evolutionChartInstance.destroy();
            if (distributionChartInstance) distributionChartInstance.destroy();
        };
    };

    const cleanup = initializeCharts();
    
    return cleanup;

  }, []);

  return (
    <section id="dashboard" className="mb-12">
      <div className="flex items-center justify-between mb-6">
          <div>
              <h2 className="heading-font text-3xl font-bold mb-2">Dashboard Executivo</h2>
              <p className="text-gray-300">Visão geral da sua produtividade jurídica</p>
          </div>
          <div className="flex space-x-3">
              <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors">
                  <i className="fas fa-plus mr-2"></i> Novo Processo
              </button>
              <button className="px-4 py-2 gold-gradient text-gray-900 rounded-lg hover:opacity-90 transition-opacity font-semibold">
                  <i className="fas fa-download mr-2"></i> Relatório
              </button>
          </div>
      </div>

      {/* Cartões de Métricas */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="metric-card rounded-xl p-6 card-hover">
              <div className="flex items-center justify-between mb-4">
                  <div className="bg-blue-600 p-3 rounded-lg">
                      <i className="fas fa-folder-open text-white text-xl"></i>
                  </div>
                  <span className="text-sm text-green-400 font-semibold">+12%</span>
              </div>
              <h3 className="text-2xl font-bold mb-1">24</h3>
              <p className="text-gray-300">Processos Ativos</p>
          </div>

          <div className="metric-card rounded-xl p-6 card-hover">
              <div className="flex items-center justify-between mb-4">
                  <div className="bg-yellow-600 p-3 rounded-lg">
                      <i className="fas fa-clock text-white text-xl"></i>
                  </div>
                  <span className="text-sm text-red-400 font-semibold">-3%</span>
              </div>
              <h3 className="text-2xl font-bold mb-1">8</h3>
              <p className="text-gray-300">Prazos Pendentes</p>
          </div>

          <div className="metric-card rounded-xl p-6 card-hover">
              <div className="flex items-center justify-between mb-4">
                  <div className="bg-green-600 p-3 rounded-lg">
                      <i className="fas fa-check-circle text-white text-xl"></i>
                  </div>
                  <span className="text-sm text-green-400 font-semibold">+25%</span>
              </div>
              <h3 className="text-2xl font-bold mb-1">156</h3>
              <p className="text-gray-300">Tarefas Concluídas</p>
          </div>

          <div className="metric-card rounded-xl p-6 card-hover">
              <div className="flex items-center justify-between mb-4">
                  <div className="gold-gradient p-3 rounded-lg">
                      <i className="fas fa-trophy text-gray-900 text-xl"></i>
                  </div>
                  <span className="text-sm text-green-400 font-semibold">+8%</span>
              </div>
              <h3 className="text-2xl font-bold mb-1">92%</h3>
              <p className="text-gray-300">Taxa de Sucesso</p>
          </div>
      </div>

      {/* Gráficos */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          <div className="glass-effect rounded-xl p-6">
              <h3 className="text-xl font-semibold mb-4 flex items-center">
                  <i className="fas fa-chart-line mr-3 text-blue-400"></i>
                  Evolução Mensal
              </h3>
              <div className="chart-container">
                  <canvas id="evolutionChart"></canvas>
              </div>
          </div>

          <div className="glass-effect rounded-xl p-6">
              <h3 className="text-xl font-semibold mb-4 flex items-center">
                  <i className="fas fa-chart-pie mr-3 text-yellow-400"></i>
                  Distribuição por Área
              </h3>
              <div className="chart-container">
                  <canvas id="distributionChart"></canvas>
              </div>
          </div>
      </div>
    </section>
  );
};

export default Dashboard;
